import { FORM_MODE } from '@/util/common-constant';

export default {
  setLoading(state, loading) {
    state.loading = loading;
  },
  getAllSuccess(state, data) {
    state.list = data;
    state.loading = false;
  },
  getCategoriesSuccess(state, data) {
    console.log(data);
    state.categories = data;
  },
  preCreate(state) {
    state.visible = true;
    state.formMode = FORM_MODE.CREATE;
    state.procedure = {
      id: null,
      title: '',
      status: 1,
      general: '',
      sequence: '',
      profile: '',
      condition: '',
    };
  },
  setFormValue(state, { procedure, formMode }) {
    state.visible = true;
    state.formMode = formMode;
    state.procedure = {
      ...procedure,
    };
  },
};
